// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-btns[data-v-7169d91c] {\n  display: inline-block;\n  position: absolute;\n  right: 60px;\n  margin-top: 4px;\n  z-index: 1;\n}\n.goodsTable[data-v-7169d91c] {\n  position: relative;\n  z-index: 1;\n}", ""]);
// Exports
module.exports = exports;
